<div class="flex flex-col gap-2">
  <label class="form-label"> {{ label }} </label>
  <textarea
    rows="3"
    [formControl]="control"
    [placeholder]="placeholder"
    class="w-full form-input"
  >
    Default text can go here.
</textarea
  >
  @if (isFieldInvalid()) {
  <span class="form-span--error">Vous avez dépassez 300 caractéres.</span>
  }
</div>
